// Module
var code = "<div class=\"cu-p-3\" with-unison> <div class=\"cu-text-meta-tag cu-mb-2\">Filter Options</div> <search-filter key=\"state\" label=\"State\"> <search-filter-radio-buttons options=\"::model.stateOptions\"></search-filter-radio-buttons> </search-filter> </div> ";
// Exports
module.exports = code;